import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { SosAlert } from '../sos-alert.model'

@Component({
  selector: 'lin-sos-acknowledge-dialog',
  templateUrl: './sos-acknowledge-dialog.component.html',
  styleUrls: ['./sos-acknowledge-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SosAcknowledgeDialogComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<SosAcknowledgeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly alert: SosAlert,
  ) {}

  confirm(note: string): void {
    this.dialogRef.close({ note: (note || '').trim() })
  }

  cancel(): void {
    this.dialogRef.close()
  }
}
